<template>
    <div>
        <div v-if="!reported">
            <button class="btn text-danger dropdown-toggle btn-sm mx-2 py-2" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="mdi mdi-flag"></i> Report
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li v-for="reason in reasons" :key="reason">
                    <a class="dropdown-item" href="javascript:void(0)" @click="report(reason)">{{ reason }}</a>
                </li>
            </ul>
        </div>
        <button  v-else class="btn text-danger  btn-sm mx-2 py-2" >
            Reported
        </button>
    </div>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    components: {
    },
    props: {
        discussion_id: {
            required: true,
        }
    },
    data() {
        return {
            // form_options: {},
            // item: {},
            // validationErrors: null,
            // error_message: null,
            reported: false,
            reasons: [
                'Abuse or Harassment',
                'Misinformation',
                'Cheating or Model Answers',
                'Inappropriate Content',
                'Spam or Advertising',
                'Hate Speech or Discrimination',
                'Improper Use of Educational Resources'
            ],
        }
    },
    created() {
    },
    methods: {
        // isInvalid( name ) {
        //     return this.validationErrors != null ? this.validationErrors[name]?.join() : false;
        // },
        report(reason) {
            const id = toast.info('Submitting report...', { icon: 'fa-solid fa-cloud-arrow-up' });
            let formData = new FormData();
            formData.append('discussion_id', this.discussion_id);
            formData.append('reason', reason);
            formData.append('subscribe_id', this.$route?.params?.subscribe_id);

            axios.post('discussion_reports', formData)
                .then(response => {
                    toast.dismiss(id);
                    toast.success(response.data.message, { timeout: 3000 }, { icon: 'fa-solid fa-circle-check' });
                    this.reported = true;
                })
                .catch(function (error) {
                    toast.dismiss(id);
                    if (error.response) {
                        toast.error(error.response.data.message, { timeout: 3000 }, { icon: 'fa-solid fa-circle-exclamation' });
                    }
                });
        }
        // report() {
        //
        //     const id = toast.info('creating ...',{ icon: 'fa-solid fa-cloud-arrow-up'  });
        //
        //     const that = this;
        //     // this.validationErrors = null;
        //     // this.error_message = null;
        //
        //
        //     let formData = new FormData();
        //     // Object.entries(this.item).forEach(([key, value]) => {
        //     //     formData.append(key, value);
        //     // });
        //     formData.append('discussion_id', this.discussion_id);
        //
        //     axios.post('discussion_reports',
        //         formData
        //     ).then(response => {
        //         toast.dismiss(id);
        //
        //         toast.success(response.data.message  ,{
        //             timeout: 3000,
        //         },{ icon: 'fa-solid fa-circle-check'  });
        //
        //         // this.item = {};
        //         // this.$router.push({name: 'home'});
        //
        //     }) .catch(function (error) {
        //         toast.dismiss(id);
        //         if (error.response) {
        //             // that.validationErrors = error.response.data.errors ;
        //             // that.error_message = error.response.data.message ;
        //             toast.error(error.response.data.message  ,{
        //                 timeout: 3000,
        //             },{ icon: 'fa-solid fa-circle-exclamation'  });
        //         }
        //     });
        //
        // }
    }
}
</script>
